import { doRequest, HttpMethodEnum } from '../lib/httpHelper';
import { Service } from './service';

export default class OrderService extends Service {
  async get(userId: string, status: string = 'active', page: number = 1) {
    return await doRequest({
      auth: true,
      url: `${this.root}v2/users/${userId}/orders`,
      method: HttpMethodEnum.GET,
      params: { status, page },
    });
  }

  async postBacardiOrder(body: any) {
    return await doRequest({
      auth: false,
      url: `${this.root}v1/various/bacardi-checkout`,
      method: HttpMethodEnum.POST,
      body,
    });
  }

  async postMartiniOrder(body: any) {
    return await doRequest({
      auth: false,
      url: `${this.root}v1/various/martini-checkout`,
      method: HttpMethodEnum.POST,
      body,
    });
  }
}
